import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  borderRadius,
  fontSize,
  pxToRem,
  size,
} from '@twistopayments/design-system/styles'

export const paper = (theme: Theme) => css`
  scroll-snap-align: center;
  scroll-snap-stop: always;
  flex-shrink: 0;
  width: 84%;
  box-shadow: 0 ${size[4]} ${size[20]} rgba(130, 139, 153, 0.2);
  border-radius: ${theme.borderRadius.md};
  margin-right: ${size[24]};
  position: relative;
  overflow: hidden;
  padding: 3rem ${size[20]} ${size[20]} ${size[20]};

  &:first-child {
    margin-left: ${size[24]};
  }
`

export const mobile = css`
  padding-top: 2em;
  padding-bottom: 1em;
  width: 100vw;
  margin: 0 auto;
  position: relative;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  overflow-x: scroll;
  display: flex;
`

export const features = css`
  margin: 0;
  padding: 0;
  list-style-type: none;
`

export const feature = css`
  display: flex;
  align-items: center;
  gap: ${size[12]};
  padding-block: ${size[12]};
  position: relative;

  &::after {
    content: '';
    display: block;
    height: 1px;
    width: 100%;
    background: linear-gradient(
      90deg,
      rgba(42, 39, 46, 0) 0,
      rgba(42, 39, 46, 0.1) 20%,
      rgba(42, 39, 46, 0.1) 80%,
      rgba(42, 39, 46, 0) 100%
    );
    position: absolute;
    bottom: 0;
    left: 0;
  }
`

export const planName = css`
  margin: 0 0 ${size[8]};
  font-size: ${fontSize.xl};
  font-weight: 500;
`
export const planPrice = css`
  margin: 0 0 ${size[20]};
  font-size: ${fontSize.md};
  font-weight: 500;
`
export const planDescription = css`
  margin: 0 0 ${size[24]};
  font-size: ${pxToRem(20)};
`

export const featureName = css`
  margin: 0;
  font-size: ${fontSize.sm};
  font-weight: 500;
`

export const dots = css`
  text-align: center;
  margin-bottom: 2em;
`

export const dot = css`
  width: ${size[8]};
  height: ${size[8]};
  padding: 0;
  margin: 0 2px;
  background-color: #e0e2e5;
  border: none;
  border-radius: ${borderRadius.circle};
`
export const activeDot = (theme: Theme) => css`
  background-color: ${theme.palette.secondary.mainContrast};
`
